// engine
import { soundService } from "@aceroll/core";

const SOUNDS = [
	0,
	'bonus_landed_1',
	'bonus_landed_2',
	'bonus_landed_3'
];

class ScatterCounterService {
	#counts = {};
	add(symbolId) {
		this.#counts[symbolId] = (this.#counts[symbolId] || 0) + 1;
		soundService.play(SOUNDS[this.#counts[symbolId]]);
	}

	getCount(symbolId) {
		return this.#counts[symbolId];
	}

	reset(symbolId) {
		if (symbolId) {
			this.#counts[symbolId] = 0;
		} else {
			this.#counts = {};
		}

	}
}

export const scatterCounterService = new ScatterCounterService();
